import React, { createContext, useCallback, useContext, useEffect, useRef } from 'react';

type AnalyticsMetadataContextValue = () => Record<string, unknown>;

const AnalyticsMetadataContext = createContext<AnalyticsMetadataContextValue>(() => ({}));

interface AnalyticsMetadataProviderProps {
  data: Record<string, unknown>;
  children: React.ReactNode;
}

export const useAnalyticsMetadata = () => useContext(AnalyticsMetadataContext);

export const AnalyticsMetadataProvider: React.FC<AnalyticsMetadataProviderProps> = ({
  data,
  children,
}) => {
  const latestValue = useRef(data);

  useEffect(() => {
    latestValue.current = data;
  }, [data]);

  const getParentMetadata = useContext(AnalyticsMetadataContext);

  const getMetadata = useCallback(
    () => ({
      ...getParentMetadata(),
      ...latestValue.current,
    }),
    [getParentMetadata]
  );

  return (
    <AnalyticsMetadataContext.Provider value={getMetadata}>
      {children}
    </AnalyticsMetadataContext.Provider>
  );
};
